import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: false,

    interpolation: {
      escapeValue: false,
      format: function (value, format, lng) {
        if (format === 'number') {
          return new Intl.NumberFormat(lng).format(value)
        }
        return value
      },
    },

    supportedLngs: ['ko', 'en'],

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    ns: [
      'translation',
      'common',
      'auth',
      'menu',
      'menuManagement',
      'todo',
      'dashboard',
      'merchant',
      'fileUpload',
      'merchantPaymentMethod',
      'payment',
      'paymentMethodConfig',
      'refund',
      'refundApprovalRequest',
      'autoRefund',
      'settlement',
      'currency',
      'cryptoRefundFee',
      'merchantCryptoRefundFee',
      'exchangeRate',
      'withdrawal',
      'beneficiary',
      'profile',
      'merchantUsers',
      'apiKeys',
      'gateway',
      'channel',
      'channelFund',
      'routing',
      'paymentMethod',
      'webhookEvent',
      'account',
      'payout',
      'feeSettings',
      'topup',
      'onramp',
      'offramp',
      'internalAccount',
      'systemSettings',
      'topupAddress',
      'channelTransfer',
      'channelRouting',
      'riskManagement',
      'amlAlert',
      'exceptionalTransfer',
      'twoFactor',
      'ipWhitelist',
    ],
    defaultNS: 'translation',

    detection: {
      order: ['localStorage', 'cookie', 'navigator'],
      caches: ['localStorage', 'cookie'],
    },
  })

export default i18n
